import React from 'react';
import { Section, Title, Card, CardTitle, CardText } from './Styled';
import { theme } from '../theme';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Benefits: React.FC = () => {
  const { language } = useLanguage();
  const t = translations.benefits[language];

  return (
    <Section id="benefits" bg={theme.colors.black}>
      <Title style={{ color: theme.colors.green }}>{t.title}</Title>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', gap: '1.5rem' }}>
        {t.items.map((b, idx) => (
          <Card key={idx} bg={theme.colors.gray} color={theme.colors.white}>
            <CardTitle>{b.title}</CardTitle>
            <CardText>{b.desc}</CardText>
          </Card>
        ))}
      </div>
    </Section>
  );
};

export default Benefits;
